import * as React from 'react';
import {
    List,
    Datagrid,
    DateField,
    TextField,
    SearchInput,
    ReferenceInput,
    AutocompleteInput,
} from 'react-admin';
import { useMediaQuery, Theme } from '@mui/material';
import { Page } from '../types';

import MobileGrid from './MobileGrid';

const cityOptionRenderer = (choice: Page) =>
    `${choice.title_selector} (${choice.geo_id}/${choice.fias_id})`;

const entityFilters = [
    <SearchInput source="q" alwaysOn />,
    <ReferenceInput
        source="from_geo_id"
        reference="logix_cities"
        filter={{ type: 'locality' }}
        alwaysOn
    >
        <AutocompleteInput optionText={cityOptionRenderer} fullWidth />
    </ReferenceInput>,
    <ReferenceInput source="to_geo_id" reference="logix_cities" alwaysOn>
        <AutocompleteInput optionText={cityOptionRenderer} fullWidth />
    </ReferenceInput>,
];

const EntityList = () => {
    const isXsmall = useMediaQuery<Theme>(theme =>
        theme.breakpoints.down('sm')
    );
    // const isSmall = useMediaQuery<Theme>(theme => theme.breakpoints.down('md'));
    return (
        // @ts-ignore
        <List
            filters={entityFilters}
            resource="logix_geo_map_overrides"
            sort={{ field: 'id', order: 'ASC' }}
            perPage={25}
        >
            {isXsmall ? (
                <MobileGrid />
            ) : (
                <Datagrid
                    optimized
                    rowClick="edit"
                    sx={{
                        '& .column-groups': {
                            md: { display: 'none' },
                            lg: { display: 'table-cell' },
                        },
                    }}
                >
                    <TextField source="id" />
                    <TextField source="from_geo.title_selector" />
                    <TextField source="to_geo.title_selector" />
                    <TextField source="description" />
                    <DateField source="created" showTime={true} />
                    <DateField source="modified" showTime={true} />
                </Datagrid>
            )}
        </List>
    );
};

export default EntityList;
